import { LIVE_API } from "./api";

export const TWITTER_CLIENT_ID = 'N2hNMUZDZjNZT0w3WkpVSEZ0R1g6MTpjaQ';
export const GOOGLE_CLIENT_ID = '466192424702-c542t25gv7ju9bjvpee935oo9b1enscm.apps.googleusercontent.com';
export const GOOGLE_CLIENT_SECRET = 'c0ZSs68M4CL6_emnsP0WekeH';
export const FACEBOOK_CLIENT_ID = '117029975354072';
export const FACEBOOK_CLIENT_SECRET = '0cd429359e4892f79065f9810d5c906c';
export const INSTA_CLIENT_ID = '584902894093140';
export const INSTA_CLIENT_SECRET = '48c75d71ec8faf89c59b6f4d69bccb89';
export const SLACK_CLIENT_ID = '503914392023.503066554869';
export const YAMMER_CLIENT_ID = LIVE_API ?'MM0Sv6O7fmXekwZOQD5COw':'IVw6M6OBcIZePKAf69mww';
export const TUMBLR_CLIENT_ID = 'JHfZX2vSxqnNFEXogrEDQiwZlhTKt7xkWO3uFRTuichUO8DYEx';
export const TUMBLR_CLIENT_SECRET = 'tZBklu1yq8fD6qn9WP7Sv9zpLJ32fc0zzbed55NMPMR4zaYO5P';
export const UPPY_KEY = "0701d3d7f8d94e92a65a9cba388b1d96";
export const UPPY_BUCKET = `cloud.socialwalls.com`;
export const UPPY_AWS_KEY = "47ABVORKG52UYE1KB28S"
export const UPPY_AWS_SECRET_KEY = "pcaTfeokaz28geAAns08H3yaGbOVz6ILgTptu19v";
export const UPPY_CAMPAION_URL  = "https://app.taggbox.com";
export const UPPY_BUCKET_URL  = `https://cloud.socialwalls.com/`;
export const ENCRYPTION_KEY = "Taggbox";
export const CAPTCHA_SITE_KEY = "6Lc6qwsqAAAAANiQhYrVmvihSIcxpivPfCD5mFg1"
export const WALL_ROUTES = ["index", "analytic", "preview",'publish','authCallback','personalize','feeds', 'photobooth', 'snapup'];
export const TEMP_URL = `${UPPY_BUCKET_URL}media/tmpimages/`;
export const ASSETS_URL = `https://assets.socialwalls.com/?url=`